import {useQueries, useQueryClient} from '@tanstack/react-query'
import {getCategoryList} from '@/services/CategoryService/category'

export const useCategoryList = (enabled=true) => {
  const results = useQueries({
    queries: [
      {
        queryKey: ['CATEGORY_LIST'],
        queryFn: getCategoryList,
        enabled: enabled
      },
    ],
  })

  const queryClient = useQueryClient();
  const fetchCategoryList = async () => {
    const data = await queryClient.fetchQuery({
     queryKey: ['CATEGORY_LIST'], 
     queryFn: getCategoryList
    });
    return data?.data || [];
  };

  return {
    categoryListData: results?.[0]?.data?.data || [],
    fetchCategoryList
  }
}
